import * as React from 'react';
import { destroy } from 'redux-form';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import ChecklistMaintenance from './ChecklistMaintenance';
import ChecklistMaintenanceProps from './ChecklistMaintenance.properties';
import { actions as formActions } from 'ducks/form';
import { selectors as uiSelectors } from 'ducks/ui';
import { actions as checklistActions } from 'ducks/checklistMaintenance/checklist';

const mapStateToProps = (state) => ({
  isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    changeSelectedForm: formActions.setSelected,
    getFormSchema: formActions.search,
    resetSearchLookupDrawer: checklistActions.reset,
    destoryForm: () => destroy('ChecklistMaintenanceDetail'),
  },
  dispatch);

export default connect(mapStateToProps, mapDispatchToProps)((props: Readonly<
  ChecklistMaintenanceProps>) => {
  return (<ChecklistMaintenance
    {...props} />);
});
